var CryptoJS = require('crypto-js');

const testing = false;
const enc_key = testing ? '4AB3DAE85A315BEF5C5040E2E2952ADCBF817BFD92CAD21E9E61BA0A190BE84D' :  'BCD37CF1A3B4A23144F015F27E25B10BF29723503B8A73CA6900F4B9B14F7A43';
const enc_iv = testing ? 'E4C9287B6AE464A5DC15FD593E31B51C' : '2BAD254FBC3B4BBE71B43625F3B9F027';

exports.encrypt = (plaintext) => {
    var nonce = CryptoJS.lib.WordArray.random(1).toString();
    var iv = CryptoJS.enc.Hex.parse(enc_iv);
    var key = CryptoJS.enc.Hex.parse(enc_key);
    var nonce_plaintext =  nonce + plaintext;
    var ct = CryptoJS.AES.encrypt(nonce_plaintext, key, 
    { iv: iv, mode:CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }); 
    return ct.ciphertext.toString(); 
}

exports.decrypt = (plaintext) => {
    var rawData = CryptoJS.enc.Hex.parse(plaintext);
    var iv = CryptoJS.enc.Hex.parse(enc_iv);
    var key = CryptoJS.enc.Hex.parse(enc_key); 
    var decryptedText = CryptoJS.AES.decrypt({ ciphertext: rawData }, key,
    {iv: iv, mode:CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7}).toString().slice(4);
    decryptedText = CryptoJS.enc.Hex.parse(decryptedText).toString(CryptoJS.enc.Utf8);
    return decryptedText;
}
